export const meta: BlockMeta = {
  title: "Featured Links",
  tags: ["subpage"],
  flags: {
    fullWidth: true,
  },
}

import { FormattedTitle } from "@components/atoms/FormattedTitle"
import { Themed, THEMES } from "@components/atoms/Themed"
import { ParallaxCarousel } from "@components/media/ParallaxCarousel"
import { Gradient } from "@components/motion/Gradient"
import { Button } from "@components/ui/Button"
import { IconChevronRight } from "@components/ui/Icon"
import { useIsMobile } from "@hooks/useIsMobile"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { Link } from "eddev/routing"

export default defineBlock("content/featured-links", (props) => {
  const isMobile = useIsMobile()
  const themeLight = THEMES[`${props.theme}-light`] ? `${props.theme}-light` : props.theme!
  const image = {
    aspect: props.image?.mediaDetails?.width! / props.image?.mediaDetails?.height!,
    srcSet: props.image?.srcSet || "",
  }

  return (
    <Themed
      theme={props.theme!}
      type="bg"
      className="w-full my-10 py-6 px-4 md:px-0 relative flex flex-col md:flex-row gap-8 md:gap-0"
    >
      <Gradient
        theme={props.theme!}
        className="absolute left-0 top-0 h-full bg-white"
        aspect="1/1"
        showImage={false}
        cutEdges={false}
        align="left"
        scale={1}
        bg={{ r: 1, g: 1, b: 1 }}
      />

      <div className="w-full md:w-1/2 h-blockFeaturedLinksH shrink-0 flex gap-4 flex-nowrap justify-center items-center overflow-hidden relative">
        <ParallaxCarousel
          className="h-full"
          images={[image, image]}
          startIndex={1}
          inactiveWidth={0.25}
          activeWidth={isMobile ? 1 : 1.4}
          useCurrentOffset={false}
          controls={false}
          align="left"
        />
        {props.featuredText && (
          <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center">
            <FormattedTitle text={props.featuredText} theme={themeLight} scale={isMobile ? 1 : 1.4} />
          </div>
        )}
      </div>

      <div className="flex flex-col gap-6 justify-end items-center relative w-full md:w-1/2">
        <div className="w-full md:w-2/3 flex flex-col gap-6 items-center justify-center px-6">
          <div className="w-full">
            <EditableText
              store="ex-title"
              as="p"
              defaultValue="Example title"
              placeholder="Example title"
              className="type-title-xs"
              plainText
            />
          </div>
          <div className="w-full border-t border-black pt-4 flex flex-col gap-3">
            {props.links?.map((link, index) => (
              <div key={index} className="flex">
                <Link
                  href={link?.link?.url}
                  target={link?.link?.target || undefined}
                  className="!w-full px-0 flex items-center justify-between hover-link"
                >
                  <span>{link?.text}</span>
                  <IconChevronRight className="w-4 h-4" />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Themed>
  )
})
